export default (theme) => ({
    root: {},
    quickFilters: {
        height: 32,
    },
});
